import VaCustomAvatar from 'assets/images/icons/VaCustomAvatar.svg?react'
import { CallTypeToJobTypeEnum, ICall, UseCaseEnumToUseCaseIdEnum } from 'features/calls/types'
import { useEffect, useState } from 'react'
import { FaCircle } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { Button } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { dateDiffToHHMMSS } from 'utils/date'

/*import CallDisconnect from 'assets/images/icons/CallDisconnect.svg'*/
interface IProps {
  oaiClaimId: string
  callInProgress: ICall | undefined
}

export const LiveCallActionDisplay = ({ callInProgress }: IProps) => {
  const [timer, setTimer] = useState<null | string>(null)
  const navigate = useNavigate()

  useEffect(() => {
    let id: any = null
    if (callInProgress) {
      id = setInterval(() => {
        const diff = dateDiffToHHMMSS(new Date().toISOString(), callInProgress.jobStarted) || '00:00'
        setTimer(diff)
      }, 1000)
    } else {
      clearInterval(id)
      setTimer('00:00')
    }
    return () => {
      clearInterval(id)
      setTimer('00:00')
    }
  }, [callInProgress])

  const redirectToClaimCall = () => {
    if (!callInProgress) {
      console.log('callInProgress?.jobId undefined')
    }
    const claimCallPath = `calls/${callInProgress?.jobId}`

    navigate(claimCallPath)
  }

  // const handleViewLiveCall = useCallback(() => {
  //   redirectToClaimCall(oaiClaimId, callInProgress?.jobId || '')
  // }, [oaiClaimId, callInProgress?.jobId])

  const isHumanAgentCallInProgress = [
    CallTypeToJobTypeEnum.attendable,
    CallTypeToJobTypeEnum.humanAgent,
    CallTypeToJobTypeEnum.standard,
  ].includes(callInProgress?.jobType as CallTypeToJobTypeEnum)

  const LiveCallAction = isHumanAgentCallInProgress ? (
    <Div>
      <Button onClick={redirectToClaimCall} variant="secondary" radius="normal">
        <FaCircle className="icon" /> View Live Call
      </Button>
    </Div>
  ) : (
    <IvrCall>
      <div className="robot-container">
        <VaCustomAvatar
          style={{
            filter: 'invert(1)',
          }}
        />
      </div>
      <div className="timer-container">{timer}</div>
      <span>
        {callInProgress?.useCase === UseCaseEnumToUseCaseIdEnum.CSI && 'Fetching ECS'}
        {callInProgress?.useCase === UseCaseEnumToUseCaseIdEnum.EBV && 'Fetching Eligibility & Benefits'}
        {callInProgress?.useCase === UseCaseEnumToUseCaseIdEnum.EOB && 'Fetching EOB'}
      </span>
    </IvrCall>
  )
  return LiveCallAction
}

const Div = styled.div`
  margin-right: 1rem;
`

const IvrCall = styled.div`
  /* width: 382px; */
  height: 3rem;
  display: flex;
  align-items: center;
  border-radius: 10px;
  background-color: #edf8fa;
  margin: 0 0.9375rem;
  .robot-container {
    align-items: center;
    display: flex;
    width: 3rem;
    height: 3rem;
    padding: 0.6875rem 0.7rem 0.8125rem 0.6875rem;
    border-radius: 10px;
    background-color: #002366;
    color: ${({ theme }) => theme.colors.neutral.lightest};
  }
  .timer-container {
    width: auto;
    height: 2.3125rem;
    margin: 0 0.5rem 0 0;
    padding: 0.6813rem 0.875rem 0.6813rem 0.875rem;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    background-color: ${({ theme }) => theme.colors.neutral.lightest};

    font-family: Milliard;
    font-size: 1rem;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #002366;
  }
  span {
    margin: 0 0.75rem 0 0.5rem;
    font-size: 1rem;
    font-weight: 600;
    white-space: nowrap;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: right;
    color: #002366;
  }
  .call-disconnect {
    width: 2rem;
    height: 2rem;
    margin-right: 0.5rem;
  }
`
